export default __webpack_public_path__ + "images/afbcc3ab39c035e2451c7bf1abd6dfb8-mental_health_small.webp";